export default function InputExcelFile({ onUploadStart, onUploadEnded, accept ,  handleChange, ...props }) {

    function readFileAsync(file) {
        return new Promise((resolve, reject) => {
            let reader = new FileReader();
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        })
    }
    const fileReadHandler = async (e) => {
        try {
            onUploadStart()
            let base64 = await readFileAsync(e.target.files[0])
            handleChange({ target: { name: e.target.name, value: base64 } })
        } catch (error) {
            console.log("error")
            console.log(error)
        } finally {
            onUploadEnded()
        }
    }
    return (
        <input
            onClick={(e) => { e.target.value = '' }}
            onChange={fileReadHandler}
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            type="file"
            hidden
            {...props}
        />
    )
}
